module.exports = __webpack_public_path__ + "static/media/Alba soffa 2,5-sits öppet avslut tyg Aragon light grey detalj 2024 2 fyrkant.d61c0c3f.jpg";